export default __webpack_public_path__ + "static/media/Front-PouleDor-Hadath.984c1a7f.jpg";